import { background, extra, primary, secondary, text } from './palettes';

const colors = {
  primary: {
    ...primary,
  },
  secondary: {
    ...secondary,
  },
  background: {
    ...background,
  },
  text: {
    ...text,
  },
  extra: {
    ...extra,
  },
  // had to add these in because of the way that Progress from chakra works (asks for a theme)
  customTeal: {
    500: '#00D2AD',
  },
  customRed: {
    500: '#D84545',
  },
  customYellow: {
    500: '#FCD446',
  },
};

export default colors;
